var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, Fragment } from "react";
import groupBy from "lodash.groupby";
import { InputGroup, InputLabel, useNotificationsCtx, TNotificationType, Loader, } from "@gw/component-library";
import { useBNIdentity } from "@gw/bn-identity";
import { UserProfileStyled } from "./UserProfileStyled";
import { useUserProfileFormFields } from "./UserProfileForm/useUserProfileFormFields";
var UserProfile = function () {
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var fieldList = useUserProfileFormFields().fieldList;
    var userProfile = useBNIdentity().userProfile;
    var addNotification = useNotificationsCtx().addNotification;
    var groupBySection = groupBy(fieldList, "section");
    useEffect(function () {
        try {
            var fetchUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, userProfile().then(function (user) {
                                fieldList.map(function (field) {
                                    var userHasPayloadKey = Object.prototype.hasOwnProperty.call(user, field.payloadKey);
                                    if (userHasPayloadKey) {
                                        field.setter(user[field.payloadKey]);
                                    }
                                });
                                setIsLoading(false);
                            })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            fetchUserProfile();
        }
        catch (err) {
            addNotification("There was an error when loading your profile!", TNotificationType.error);
        }
    }, []);
    return (React.createElement(UserProfileStyled, null,
        React.createElement("p", null, "Your profile information is sent to farmers when you contact them through Seaweed Source."),
        React.createElement("p", null,
            "If you want to update your profile information, please email",
            " ",
            React.createElement("a", { href: "mailto:support@greenwave.org" }, "support@greenwave.org"),
            "."),
        React.createElement("hr", null),
        isLoading ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null, Object.entries(groupBySection).map(function (_a) {
            var group = _a[0], fields = _a[1];
            var filteredFields = fields.filter(function (field) { return field.value; });
            return (filteredFields.length > 0 && (React.createElement(Fragment, { key: group },
                React.createElement("h2", null, group),
                React.createElement("div", { className: "wrap-fields" }, filteredFields.map(function (field) { return (React.createElement(InputGroup, { className: field.container, key: "field-" + field.name },
                    React.createElement(InputLabel, null, field.label),
                    React.createElement("p", { className: "user-field" }, field.value))); })))));
        })))));
};
export default UserProfile;
//# sourceMappingURL=UserProfile.js.map